import React, { useEffect, useState } from 'react';
import { Grid, Typography, Link, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import HomePageLayout from '../../components/homepage/HomePageLayout';
import bathymetryThumb from '../../../resources/bathymetryThumb.jpg';
import shorelinesThumb from '../../../resources/shorelinesThumb.jpg';
import csqueezeThumb from '../../../resources/cqueezeThumb.jpg';
import intermareThumb from '../../../resources/intermares_logo.png';
import mepbayThumb from '../../../resources/mepbayThumb.jpg';
import shorerThumb from '../../../resources/shore_r.webp';
import shoreSThumb from '../../../resources/Shore-S.png';
import euscoastThumb from '../../../resources/euscoastThumb.jpg';
import AlgorithmCard from '../../components/acquisition/AlgorithmCard';
import ModuleIcons from '../../components/acquisition/ModuleIcons';
import { MODULE_COLORS } from '../../../common/moduleTheme';
import { push } from 'connected-react-router';
import { useDispatch } from 'react-redux';
import ReactGA from 'react-ga';

const SelectionPage = () => {
  const dispatch = useDispatch();
  const [t] = useTranslation();
  const classes = useStyles();

  const [openDisclaimer, setOpenDisclaimer] = useState(false);

  useEffect(() => {
    const accepted = sessionStorage.getItem('acceptedDisclaimer');
    !accepted && setOpenDisclaimer(true);
  }, []);

  const handleAccept = () => {
    sessionStorage.setItem('acceptedDisclaimer', 'true');
    setOpenDisclaimer(false);
  };

  const handleReject = () => {
    window.location.href = 'https://cassiengine.org/';
  };

  const handleChoice = (name) => {
    ReactGA.event({
      category: 'Algorithm',
      action: 'ChooseAlgorithm',
      value: name.split(' ', 1)[0],
    });
    name = name.toLowerCase();
    if (name.indexOf('intertidal') !== -1 || name.indexOf('intermaré') !== -1) {
      dispatch(push('intertidal/1'));
      return;
    }
    if (name.indexOf('mepbay') !== -1) {
      dispatch(push('mepbay/1'));
      return;
    }

    if (name.indexOf('shore-s') !== -1 || name.indexOf('shore_s') !== -1 || name.indexOf('shoreline-s') !== -1) {
      dispatch(push('shore_s/1'));
      return;
    }

    if (name.indexOf('shore_r') !== -1 || name.indexOf('shoreline-r') !== -1) {
      dispatch(push('shore_r/1'));
      return;
    }
    if (name.indexOf('euscoast') !== -1) {
      dispatch(push('euscoast/1'));
      return;
    }

    name.indexOf('shoreline') !== -1 || name.indexOf('linha de costa') !== -1
      ? dispatch(push('shoreline/1'))
      : name.indexOf('batimetria') !== -1 || name.indexOf('bathymetry') !== -1
        ? dispatch(push('bathymetry/1'))
        : dispatch(push('csqueeze/1'));
  };

  const availableAlgorithms = [
    {
      name: t('forms.algorithm.shoreline'),
      color: MODULE_COLORS.shoreline,
      Icon: ModuleIcons.shoreline,
      image: shorelinesThumb,
      description: t('forms.algorithm.shorelineDesc'),
      enabled: true,
    },
    {
      name: t('forms.algorithm.shore_r'),
      beta: true,
      color: MODULE_COLORS.shore_r,
      Icon: ModuleIcons.shore_r,
      image: shorerThumb,
      description: t('forms.algorithm.shore_rDesc'),
      enabled: true,
    },
    {
      name: t('forms.algorithm.shore_s'),
      color: MODULE_COLORS.shore_s,
      Icon: ModuleIcons.shore_s,
      image: shoreSThumb,
      description: t('forms.algorithm.shore_sDesc'),
      enabled: true,
      beta: true,
    },
    {
      name: t('forms.algorithm.mepbay'),
      beta: true,
      color: MODULE_COLORS.mepbay,
      Icon: ModuleIcons.mepbay,
      image: mepbayThumb,
      description: t('forms.algorithm.mepbayDesc'),
      enabled: true,
    },
    {
      name: t('forms.algorithm.intermare'),
      beta: true,
      color: MODULE_COLORS.intermare,
      Icon: ModuleIcons.intermare,
      image: intermareThumb,
      description: t('forms.algorithm.intermareDesc'),
      enabled: true,
    },
    {
      name: t('forms.algorithm.csqueeze'),
      beta: true,
      color: MODULE_COLORS.csqueeze,
      Icon: ModuleIcons.csqueeze,
      image: csqueezeThumb,
      description: t('forms.algorithm.csqueezeDesc'),
      enabled: true,
    },
    {
      name: t('forms.algorithm.euscoast'),
      beta: true,
      color: MODULE_COLORS.euscoast,
      Icon: ModuleIcons.euscoast,
      image: euscoastThumb,
      description: t('forms.algorithm.euscoastDesc'),
      enabled: true,
    },
    {
      name: t('forms.algorithm.bathymetry'),
      beta: true,
      color: MODULE_COLORS.bathymetry,
      Icon: ModuleIcons.bathymetry,
      image: bathymetryThumb,
      description: t('forms.algorithm.bathymetryDesc'),
      enabled: true,
    }, 
  ];

  return (
    <HomePageLayout>
      <div className={classes.wrapper}>
        <Grid item xs={12} className={classes.header}>
          <Typography className={classes.title} variant="h4" align="center">
            {t('forms.algorithm.title')}
          </Typography>
        </Grid>
        <div id="algorithmchooser" className={classes.grid}>
          {availableAlgorithms.map((algorithm, i) => (
            <div key={i} id={algorithm.name} className={classes.item}>
              <AlgorithmCard
                name={algorithm.name}
                beta={algorithm.beta}
                color={algorithm.color}
                Icon={algorithm.Icon}
                image={algorithm.image}
                description={algorithm.description}
                onChoose={() => handleChoice(algorithm.name)}
                enabled={algorithm.enabled}
              />
            </div>
          ))}
        </div>
      </div>

      <Dialog open={openDisclaimer} disableEscapeKeyDown>
        <DialogTitle>{t('forms.algorithm.disclaimerTitle')}</DialogTitle>
        <DialogContent>
          <Typography variant="body1" paragraph>
            {t('forms.algorithm.disclaimerText')}{' '}
            <Link href="https://earthengine.google.com/commercial/" target="_blank" rel="noopener noreferrer">
              https://earthengine.google.com/commercial/
            </Link>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReject} color="secondary">
            {t('forms.algorithm.disclaimerReject')}
          </Button>
          <Button onClick={handleAccept} color="primary" autoFocus>
            {t('forms.algorithm.disclaimerAccept')}
          </Button>
        </DialogActions>
      </Dialog>
    </HomePageLayout>
  );

  function scriptToTest() {
    //write here code to test from GEE Code Editor on CASSIE
    return false;
  }
};

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexFlow: 'column',
    flexGrow: 1,
  },
  header: {
    backgroundColor: theme.palette.primary[400],
    padding: theme.spacing(6),
  },
  title: {
    color: 'white',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column',
  },
  content: {
    width: '80vw',
    maxWidth: '1000px',
    marginTop: theme.spacing(-9),
  },
  instructions: {
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  grid: {
    margin: theme.spacing(6, 4),
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(4),
    justifyContent: 'center',
  },
  item: {
    maxHeight: '500px',
    width: '100%',
    maxWidth: '378px',
    minWidth: '300px',
    flex: '0 0 auto',
  },
}));

export default SelectionPage;
